<template>
  <van-popup
    :value="value"
    @input="input"
    position="center"
    round
    :close-on-click-overlay="false"
  >
    <div
      style="width:80vw;max-width:80vw;height:352px;"
      class="flex flex-col items-center p-4"
    >
      <div class="text-center main-color">Completed {{counterText}}</div>
      <div
        class="flex flex-row items-center justify-between"
        style="margin-top:67px;width:100%"
      >
        <van-image
          :src="productInfo.deviceImage"
          width="74"
          height="137"
          style="min-width:74px"
        />
        <div class="ml-9 flex flex-col flex-1" style="overflow-y: scroll;">
          <div>{{ productInfo.deviceName }}</div>
          <div class="third-color text-14px">{{ tagId }}</div>
          <div class="flavor-name-tags">
            <div class="flavor-tag-content">
              <span
                v-for="(tag, index) in tags"
                :key="index"
                class="flavor-tag"
                >{{ tag.labelName }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="showButton"
        class="flex flex-row items-center text-center gap-3 mt-10 w-full"
      >
        <div
            @click="onComplete"
            class="flex-1 text-white write-btn"
            style="background: #121212"
        >
          Complete
        </div>
        <div
            @click="onContinue"
            class="flex-1 main-color write-btn radius-border"
            style="background: white"
        >
          Continue
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: "PopupFlavorWriteResult",
  props: {
    counter: {
      type:Number,
      default: 0
    },
    showButton: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: true
    },
    productInfo: {
      type: Object,
      default: () => {
        return {
          deviceName: "D019",
          deviceImage: require("@/assets/icons/v2/icon_test_device.png")
        };
      }
    },
    tagId: {
      type: String,
      default: ""
    },
    tags: {
      type: Array,
      default: () => {
        return [ ];
      }
    },
    funcType: {
      type:Number,
      default: 1 //1是扫码 2是NFC
    }
  },
  methods: {
    input(e) {
      this.$emit("input", e);
    },
    onComplete() {
      this.$emit("onComplete", false);
    },
    onContinue() {
      this.$emit("onContinue", false);
    }
  },
  computed: {
    counterText() {
      if (this.counter === 0) {
        return ''
      }
      return ` ${this.counter}`
    },
  }
};
</script>

<style scoped lang="less">
.flavor-name-tags {
  display: flex;
  flex: 1;
  flex-direction: column;

  .flavor-name {
    font-size: 15px;
  }

  .flavor-tag-content {
    margin-top: 10px;
    display: flex;
    flex: 1;
    font-size: 10px;
    flex-direction: row;
    align-items: center;
    overflow-x: auto; /* 水平方向溢出时显示滚动条 */
    white-space: nowrap; /* 禁止换行 */

    .flavor-tag {
      border-radius: 8px;
      background: var(--modeActiveBackground) !important;
      color: var(--modeActiveTextColor) !important;
      padding: 4px 8px;
      margin-right: 4px;
    }
  }
}

.write-btn {
  height: 40px;
  line-height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
